import React, { useState, useEffect, useRef } from "react";
import "./CoFilab.scss";
import dashboardIcon from "../../images/settings-dashboard.svg";
import programIcon from "../../images/settings-program.svg";
import CRMIcon from "../../images/settings-crm.svg";
import reportingIcon from "../../images/settings-reporting.svg";
import { Link, useNavigate } from "react-router-dom";
import BaseButton from "../../components/UI/BaseButton/BaseButton";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Chart from "chart.js/auto";
import { Box } from "@mui/material";

function CoFilab() {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState("");
  const navigate = useNavigate();
  const chartInstanceRef = useRef(null);
  const seasonalityChartRef = useRef(null);
  const categoryChartRef = useRef(null);

  // URLs to fetch PHP content
  const phpUrls = {
    cofi: "https://dev2.4pay.ca/lab/cofi/index.php",
    aiDecisions: "https://dev2.4pay.ca/lab/cofi/ai_decisions.php",
  };

  const settingOptions = [
    {
      icon: dashboardIcon,
      option: "CoFi Marketplace",
      description:
        "Find and Explore collaboration partnerships (by Country, Region and Industry)",
      link: "/cofilab/cofimarketplace",
    },
    {
      icon: programIcon,
      option: "Data Analytics",
      description:
        "Upload or link collaboration Datasets. All data will be securely stored in S3 bucket.",
      link: "/remittance",
    },
    {
      icon: CRMIcon,
      option: "AI Decisions Repository",
      description:
        "AI Decisions represent your initial rules used to create your financial model.",
      link: "#",
      modal: "aiDecisions",
    },
    {
      icon: reportingIcon,
      option: "CoFi Wizard",
      description:
        "Use Industry-specific models or Develop new Collaborative Finance Models and Configurations",
      link: "#",
      modal: "cofi",
    },
    {
      icon: programIcon,
      option: "CoFi Analytics",
      description:
        "Review Collaborative Wizard Outcomes (Models, Products and ROI Assessments)",
      link: "/remittance",
    },
    {
      icon: programIcon,
      option: "CoFi Dashboard",
      description: "Review Realtime CoFi Deployments",
      link: "/remittance",
    },
  ];

  const handleOpenModal = async (type) => {
    setModalType(type);
    setShowModal(true);
    setLoading(true);
    try {
      const response = await axios.get(phpUrls[type]);
      setModalContent(response.data);
    } catch (error) {
      setModalContent("Error loading content from the server");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setModalContent("");
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
      chartInstanceRef.current = null;
    }
    if (seasonalityChartRef.current) {
      seasonalityChartRef.current.destroy();
      seasonalityChartRef.current = null;
    }
    if (categoryChartRef.current) {
      categoryChartRef.current.destroy();
      categoryChartRef.current = null;
    }
  };

  useEffect(() => {
    if (showModal && !loading && modalType === "cofi") {
      const ctx = document.getElementById("tokensChart");
      if (ctx) {
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }

        chartInstanceRef.current = new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: ["Active Tokens", "Used Tokens"],
            datasets: [
              {
                data: [65, 35],
                backgroundColor: ["#2a7886", "#cccccc"],
                hoverBackgroundColor: ["#226869", "#999999"],
                borderColor: "#ffffff",
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "bottom",
              },
            },
            cutout: "70%",
          },
        });
      }

      //deploy UI modal
      const deployButtons = document.querySelectorAll(".deploy-btn");
      const deployActivityPanel = document.getElementById(
        "deployActivityPanel"
      );
      const deployclosePanel = document.getElementById("closeDeployPanel");

      deployButtons.forEach((button) => {
        button.addEventListener("click", () => {
          deployActivityPanel.classList.add("active");
        });
      });

      // Initialize ROI Report charts (Seasonality and Gig Worker Distribution)
      const roiReportButtons = document.querySelectorAll(".roi-report-btn");
      const roiPanel = document.getElementById("roiPanel");
      const closePanel = document.getElementById("closePanel");

      roiReportButtons.forEach((button) => {
        button.addEventListener("click", () => {
          roiPanel.classList.add("active");
          // Initialize charts after ROI panel is visible
          setTimeout(() => {
            const seasonalityCtx = document.getElementById("seasonalityChart");
            if (seasonalityCtx) {
              if (seasonalityChartRef.current) {
                seasonalityChartRef.current.destroy();
              }
              seasonalityChartRef.current = new Chart(seasonalityCtx, {
                type: "bar",
                data: {
                  labels: ["Winter", "Spring", "Summer", "Fall"],
                  datasets: [
                    {
                      label: "Gig Worker Activity by Season",
                      data: [30, 40, 70, 60],
                      backgroundColor: [
                        "#4caf50",
                        "#ff9800",
                        "#03a9f4",
                        "#f44336",
                      ],
                    },
                  ],
                },
                options: {
                  responsive: true,
                  scales: {
                    y: {
                      beginAtZero: true,
                    },
                  },
                },
              });
            }

            const categoryCtx = document.getElementById("categoryChart");
            if (categoryCtx) {
              if (categoryChartRef.current) {
                categoryChartRef.current.destroy();
              }
              categoryChartRef.current = new Chart(categoryCtx, {
                type: "pie",
                data: {
                  labels: [
                    "Ride-sharing",
                    "Food Delivery",
                    "Freelancing",
                    "Other",
                  ],
                  datasets: [
                    {
                      data: [40, 30, 20, 10],
                      backgroundColor: [
                        "#ff6384",
                        "#36a2eb",
                        "#cc65fe",
                        "#ffce56",
                      ],
                    },
                  ],
                },
                options: {
                  responsive: true,
                  plugins: {
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              });
            }
          }, 300);
        });
      });

      closePanel?.addEventListener("click", () => {
        roiPanel?.classList.remove("active");
      });

      deployclosePanel?.addEventListener("click", () => {
        deployActivityPanel?.classList.remove("active");
      });
    }
  }, [showModal, loading, modalType]);

  const goBack = () => {
    navigate("/settings");
  };

  return (
    <Box className="page-container settings-container">
      <Box className="header-container">
        <Box className="settings-page-title">Collaborative Finance Lab</Box>
        <Box>
          Transforming the financial services landscape through Collaborative
          Finance (CoFi) powered by AI. Connect with forward-thinking businesses
          ready to collaborate.
        </Box>
      </Box>

      <Box className="timeline-container">
        <Box className="timeline-line"></Box>
        <Box className="timeline">
          <Box className="timeline-item">
            <Box className="timeline-dot-inactive"></Box>
            <Box className="timeline-content">Set up CoFi Profile</Box>
          </Box>
          <Box className="timeline-item">
            <Box className="timeline-dot-inactive"></Box>
            <Box className="timeline-content">Load Datasets</Box>
          </Box>
          <Box className="timeline-item">
            <Box className="timeline-dot-inactive"></Box>
            <Box className="timeline-content">Set Preferences</Box>
          </Box>
          <Box className="timeline-item">
            <Box className="timeline-dot active"></Box>
            <Box className="timeline-content">Run CoFi</Box>
          </Box>
          <Box className="timeline-item">
            <Box className="timeline-dot-inactive"></Box>
            <Box className="timeline-content">Review CoFi Results</Box>
          </Box>
          <Box className="timeline-item">
            <Box className="timeline-dot-inactive"></Box>
            <Box className="timeline-content">Deploy & Launch</Box>
          </Box>
        </Box>
      </Box>

      <Box className="settings-center-container">
        <Box className="row gap-3">
          {settingOptions.map((setting) => {
            return (
              <Box
                key={setting.option}
                className="settings-card col-3"
                onClick={() =>
                  setting.link === "#"
                    ? handleOpenModal(setting.modal)
                    : navigate(setting.link)
                }
              >
                <Box className="settings-card-title-container d-flex align-items-center">
                  <img src={setting.icon} alt={setting.option} loading="lazy" />
                  <p>{setting.option}</p>
                </Box>
                <div className="settings-card-body">{setting.description}</div>
                {setting.option === "CoFi Wizard" ? (
                  <a
                    className="settings-card-link"
                    //onClick={handleWizardClick}
                  >
                    {setting.option}
                  </a>
                ) : setting.option === "AI Decisions Repository" ? (
                  <a
                    className="settings-card-link"
                    onClick={() => handleOpenModal(setting.modal)}
                  >
                    {setting.option}
                  </a>
                ) : (
                  <Link to={setting.link} className="settings-card-link">
                    <Box className="settings-card-link">{setting.option}</Box>
                  </Link>
                )}
              </Box>
            );
          })}
        </Box>
        <Box className="return-button">
          <BaseButton
            buttonText={"Return to Admin Center"}
            onClick={goBack}
          ></BaseButton>
        </Box>
      </Box>

      <Modal show={showModal} onHide={handleClose} className="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "cofi" ? "CoFi Wizard" : "AI Decisions"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal_cofi">
          {loading ? (
            <div>Loading content...</div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: modalContent }} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
}

export default CoFilab;
